import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateformatter'
})
export class DateformatterPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let arr=value.split('-');
    if(arr){
      return arr[0]+'/'+this.getMonthValue(arr[1])+'/'+(arr[2] && arr[2].length>3?arr[2].substr(2,arr[2].length):arr[2]);
    }else
    return value;
  }
  getMonthValue(value): string {
    let m = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
      "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    for (let index = 0; index < m.length; index++) {
      const element = m[index];
      if (element == value)
        return (index+1) < 10 ? '0' + (index+1) : '' + (index+1);
    }

  }

}
